import { useFormikContext } from "formik";
import { InputAdornment, TextField } from "@mui/material";
import { AddInvestmentFormValues } from "../../../types";

const QuantityField = () => {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddInvestmentFormValues>();
  return (
    <>
      <TextField
        sx={{
          minWidth: 0,
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginRight: 0,
          },
        }}
        id="quantity"
        name="quantity"
        label="Quantity"
        type="number"
        size="small"
        color="secondary"
        maxRows={1}
        autoComplete="off"
        fullWidth
        value={values["quantity"]}
        onChange={handleChange}
        error={
          (touched["quantity"] && Boolean(errors["quantity"])) ||
          (touched["unit"] && Boolean(errors["unit"]))
        }
        helperText={
          (touched["quantity"] && errors["quantity"]) ||
          (touched["unit"] && errors["unit"])
        }
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment
                data-testid="unitAdornment"
                position="start"
                title={values.unit}
                sx={{
                  flexShrink: 0,
                  maxWidth: "70%",
                  "& .MuiTypography-root": {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                }}
              >
                {values.unit ? values.unit : null}
              </InputAdornment>
            ),
          },
        }}
      />
    </>
  );
};

export default QuantityField;
